var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-49c62a29": "",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    "data-v-49c62a29": "",
    id: titleId
  }, "Accessible Station") : title ? /*#__PURE__*/React.createElement("title", {
    "data-v-49c62a29": "",
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-v-49c62a29": "",
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    "data-v-49c62a29": "",
    fill: "#00F",
    d: "M0 0h23.986v23.776H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-v-49c62a29": "",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    "data-v-49c62a29": "",
    d: "M11.202 5.22a1.495 1.495 0 01-1.514 1.473 1.498 1.498 0 01-1.496-1.495A1.495 1.495 0 019.7 3.718c.83.002 1.501.668 1.502 1.489"
  }), /*#__PURE__*/React.createElement("path", {
    "data-v-49c62a29": "",
    d: "M8.454 5.968l.64 7.367 5.449-.034 2.12 5.08 2.556-.808-.539-1.278-1.311.337-1.884-4.643h-5.08v-1.042h3.028V9.6h-3.398l-.067-2.927"
  }), /*#__PURE__*/React.createElement("path", {
    "data-v-49c62a29": "",
    d: "M8.291 9.707c-7.91 5.314 2.037 15.199 7.266 7.732l-.577-1.984c-2.325 6.416-11.813 1.253-6.593-4.004l-.096-1.744z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcc);
export default __webpack_public_path__ + "static/media/acc.063cc91c9642bd053f4ddc761ca21aea.svg";
export { ForwardRef as ReactComponent };